import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from 'lib/api/apiClient';
import { AOI_URLS } from 'lib/api/endpoints';

export const fetchSavedAOIs = createAsyncThunk('aoi/fetchSavedAOIs', async (_, thunkAPI) => {
  try {
    const response = await apiClient.get(AOI_URLS.getSavedAOIs);
    return response?.data?.data ?? response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.detail || 'Failed to fetch AOIs');
  }
});

export const saveAOI = createAsyncThunk('aoi/saveAOI', async ({ coordinates, name }, thunkAPI) => {
  try {
    const response = await apiClient.post(AOI_URLS.saveAOI, { coordinates, name });
    return response?.data?.data ?? response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.detail || 'Failed to save AOI');
  }
});

export const deleteAOI = createAsyncThunk('aoi/deleteAOI', async (aoiId, thunkAPI) => {
  try {
    await apiClient.delete(AOI_URLS.deleteAOI(aoiId));
    return aoiId;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.detail || 'Failed to delete AOI');
  }
});

const aoiSlice = createSlice({
  name: 'aoi',
  initialState: {
    drawnCoordinates: null,
    savedAOIs: [],
    activeAOIName: null,
    loading: false,
    error: null,
  },
  reducers: {
    setDrawnCoordinates(state, action) {
      state.drawnCoordinates = action.payload;
    },
    setActiveAOIName(state, action) {
      state.activeAOIName = action.payload;
    },
    clearAOI(state) {
      state.drawnCoordinates = null;
      state.activeAOIName = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavedAOIs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSavedAOIs.fulfilled, (state, action) => {
        state.loading = false;
        state.savedAOIs = action.payload;
      })
      .addCase(fetchSavedAOIs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveAOI.fulfilled, (state, action) => {
        state.savedAOIs.push(action.payload);
      })
      .addCase(deleteAOI.fulfilled, (state, action) => {
        state.savedAOIs = state.savedAOIs.filter((a) => a.id !== action.payload);
      });
  },
});

export const { setDrawnCoordinates, setActiveAOIName, clearAOI } = aoiSlice.actions;
export default aoiSlice.reducer;
